import EditEventFormPrintCoverLetter from './EditEventFormPrintCoverLetter'
import EditEventFormPrintDate from './EditEventFormPrintDate'
import EditEventFormPrintExtra from './EditEventFormPrintExtra'
import EditEventFormPrintItem from './EditEventFormPrintItem'
import EditEventFormPrintTotalTotal from './EditEventFormPrintTotalTotal'
import EditEventFormPrintType from './EditEventFormPrintType'
import EditEventFormPrintInput from './EditEventFormPrintInput'

const EditEventFormPrint = ({eventData, settings, currentLang, timezone, debug, showInBrowser}) => {
    const { form_layout, form_settings  } = settings

    return (
        <div className={'wrapper-event-print' + (showInBrowser ? ' event-print-show-in-browser' : '')}>
            <EditEventFormPrintCoverLetter
                eventData={eventData}
            />

            {form_layout.map(({element_types}) => (
                element_types.map(elementId => {
                    const { type } = form_settings.element_types.items[elementId]

                    if('input' === type) {
                        return <EditEventFormPrintInput
                            key={elementId}
                            elementId={elementId}
                            eventData={eventData}
                            form_settings={form_settings}
                        />
                    }

                    else if('event_types' === type) {
                        return <EditEventFormPrintType
                            key={elementId}
                            dataKey={type}
                            nameKey="event_type_name"
                            headline="Veranstaltungs-Art"
                            eventData={eventData}
                            form_settings={form_settings}
                        />
                    }
    
                    else if('program_types' === type) {
                        return <EditEventFormPrintType
                            key={elementId}
                            dataKey={type}
                            nameKey="program_type_name"
                            headline="Programm-Art"
                            eventData={eventData}
                            form_settings={form_settings}
                        />
                    }
    
                    else if('date_types' === type)  {
                        return <EditEventFormPrintDate
                            key={elementId}
                            eventData={eventData}
                            currentLang={currentLang}
                            timezone={timezone}
                            debug={debug}
                        />
                    }
    
                    else if('visitors' === type) {
                        return <EditEventFormPrintItem
                            key={elementId}
                            dataKey={type}
                            otherFeesKey="visitors_other_fees"
                            headline='Besucher:innen'
                            eventData={eventData}
                            form_settings={form_settings}
                        />
                    } 
    
                    else if('theatres' === type) {
                        return <EditEventFormPrintItem
                            key={elementId}
                            dataKey={type}
                            otherFeesKey="theatres_other_fees"
                            headline='Säle'
                            eventData={eventData}
                            form_settings={form_settings}
                        />
                    }
                })
            ))}

            <EditEventFormPrintExtra
                eventData={eventData}
            />

            <EditEventFormPrintTotalTotal
                eventData={eventData}
                form_settings={form_settings}
            />
        </div>
    )
}

export default EditEventFormPrint